module.exports = __webpack_public_path__ + "img/赞赏.0dff8377.gif";